import { Box, CircularProgress, Dialog, Typography } from "@mui/material";
import React from "react";

export interface LoadingDialogProps {
  open: boolean;
  message?: string;
}

const LoadingDialog: React.FC<LoadingDialogProps> = ({
  open,
  message = "Please wait..."
}) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      PaperProps={{ sx: { p: 4, textAlign: "center" } }}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <CircularProgress />
        <Typography mt={2}>{message}</Typography>
      </Box>
    </Dialog>
  );
};

export default LoadingDialog;
